import { forwardRef, Th, Tr } from "@chakra-ui/react";

export const SituationHeaderRow = forwardRef(
  ({ includeResidenceTypeDetails = false }, ref) => (
    <Tr ref={ref}>
      <Th>Id</Th>
      {includeResidenceTypeDetails && <Th>Woningtype</Th>}
      <Th>Oriëntatie</Th>
      <Th>Relatieve positie</Th>
      <Th>Aantal scenario&apos;s</Th>
      <Th>Status</Th>
      <Th>Acties</Th>
    </Tr>
  ),
);
